import { create } from "zustand";

type CalendarStatus = "connected" | "skipped" | null;

interface BusinessBasicsFormData {
  business_name: string;
  slug: string;
  address: string;
  phone: string;
  description: string;
  business_mode: string;
  timezone: string;
  country_code: string;
  currency: string;
}

interface ServiceFormData {
  name: string;
  description: string;
  duration_minutes: number;
  price: number;
}

interface StaffFormData {
  full_name: string;
  bio: string;
}

interface CategoryFormData {
  service_category_id: string;
  name: string;
}

interface StepData {
  businessBasics: Partial<BusinessBasicsFormData> | null;
  categories: CategoryFormData[] | null;
  services: ServiceFormData[] | null;
  staff: StaffFormData[] | null;
  calendar: CalendarStatus;
}

interface OnboardingState {
  currentStep: 1 | 2 | 3 | 4 | 5 | 6;
  stepData: StepData;
  saving: boolean;
  error: string | null;

  setCurrentStep: (step: 1 | 2 | 3 | 4 | 5 | 6) => void;
  setStepData: <K extends keyof StepData>(step: K, data: StepData[K]) => void;
  setSaving: (saving: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

const defaultStepData: StepData = {
  businessBasics: null,
  categories: null,
  services: null,
  staff: null,
  calendar: null,
};

export const useOnboardingStore = create<OnboardingState>((set) => ({
  currentStep: 1,
  stepData: { ...defaultStepData },
  saving: false,
  error: null,

  setCurrentStep: (step) => set({ currentStep: step }),

  setStepData: (step, data) =>
    set((state) => ({
      stepData: { ...state.stepData, [step]: data },
    })),

  setSaving: (saving) => set({ saving }),

  setError: (error) => set({ error }),

  reset: () =>
    set({
      currentStep: 1,
      stepData: { ...defaultStepData },
      saving: false,
      error: null,
    }),
}));
